export default __webpack_public_path__ + "static/media/logo.23dc7d90.svg";